import { useEffect } from "react";
import { useAuth } from "../auth/AuthContext";
import { setJobsOpenModalCallback } from "./jobsClient";

/**
 * Wires the jobs API client's "open paste modal" callback to the auth
 * provider. Mirrors the same pattern used by `api/patientRegistry.ts` —
 * the fetch wrapper is a plain module, but the modal is React state, so
 * we bridge them at mount time.
 *
 * Mounted as a child of `<AuthProvider>` so it can call `useAuth()` to
 * access `openModal`.
 */
export function JobsAuthBridge() {
    const { openModal } = useAuth();
    useEffect(() => {
        setJobsOpenModalCallback(openModal);
        return () => setJobsOpenModalCallback(() => {});
    }, [openModal]);
    return null;
}
